/**
 * Which PvP the player is asking for, chosen explicitly and once.
 *
 * ## Why there is a screen for this at all
 *
 * There are two modes with different rules, different rooms, different lobbies
 * and different results, and the button in the shell says only "PVP". Sending
 * that click straight to the duel would make 1x1 the silent default and leave
 * 3x3 reachable only by somebody who already knew it existed; sending it to the
 * team lobby would do the same in the other direction and cost a player who
 * wanted a duel five people they do not have.
 *
 * So the click opens a question. Neither answer is pre-selected, neither is
 * marked as recommended, and nothing here starts a match: pressing one of them
 * opens that mode's own lobby, which is where a room is actually asked for.
 *
 * ## What this screen deliberately does not offer
 *
 * No matchmaking, no queue, no "find me anybody", no rewards, no ranking, no
 * team preference and no memory of what was chosen last time. Every one of those
 * is a product decision nobody has made, and a default quietly applied is the
 * hardest kind of decision to notice.
 */

export interface PvpModeChoiceProps {
  readonly onChooseDuel: () => void;
  readonly onChooseTeam: () => void;
  readonly onClose: () => void;
}

export function PvpModeChoice({ onChooseDuel, onChooseTeam, onClose }: PvpModeChoiceProps) {
  return (
    <section className="pvp-panel" data-testid="pvp-mode-choice" aria-label="Escolher modo PvP">
      <header className="pvp-panel-head">
        <h2>PVP PRIVADO</h2>
        <p className="pvp-no-reward" data-testid="pvp-mode-no-reward">
          SEM RECOMPENSAS — nenhum Gold, XP ou item muda de mãos em nenhum dos modos.
        </p>
      </header>

      <div className="pvp-panel-body pvp-mode-choice">
        <button
          type="button"
          className="pvp-mode-option"
          data-testid="pvp-mode-duel"
          onClick={onChooseDuel}
        >
          <span className="pvp-mode-title">DUELO 1X1</span>
          <span className="pvp-mode-detail">Você e mais um jogador, com um código.</span>
        </button>
        <button
          type="button"
          className="pvp-mode-option"
          data-testid="pvp-mode-team"
          onClick={onChooseTeam}
        >
          <span className="pvp-mode-title">BATALHA EM EQUIPE 3X3</span>
          <span className="pvp-mode-detail">Seis jogadores, dois códigos, uma sala privada.</span>
        </button>
      </div>

      <button type="button" className="pvp-leave" data-testid="pvp-mode-close" onClick={onClose}>
        SAIR
      </button>
    </section>
  );
}
